// based on the good old https://github.com/bsusensjackson/json2csv

export class CSVConverter {
  static convert(objArray: Record<string, any>[] | string) {
    const array: Record<string, any>[] =
      typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    // Assume that the headers of the document are equal to the keys in the JSON object.
    const headers = Object.keys(array[0]);
    const stringWithHeaders = CSVConverter.parseHeaders(headers);
    return CSVConverter.parseBody(array, stringWithHeaders);
  }

  static parseHeaders(headers: string[]) {
    // Push the headers into the CSV string.
    let str = '';
    headers.forEach((item, i, list) => {
      if (i < list.length - 1) {
        str += `${item},`;
      } else {
        str += `${item}`;
      }
    });
    str += '\r\n';
    return str;
  }

  static parseBody(array: Record<string, any>[], str: string) {
    let line: string;
    array.forEach((item) => {
      line = '';
      Object.keys(item).forEach((key) => {
        if (line !== '') line += ',';
        const regex = /,/;
        let value = item[key];

        if (typeof value === 'string') {
          // Replace Unicode minus sign with ASCII hyphen
          value = value.replace(/\u2212/g, '-');
          // If the value contained in the JSON object is a string:
          // Perform a regex test to check and see if the value has a comma already in place and escape the value.
          // e.g. "Smith, Jones" as a value should not be separated two different columns.
          value = regex.test(value) ? `"${value}"` : value;
        }
        line += value;
      });
      str += `${line}\r\n`;
    });
    return str;
  }

  static download(csvString: string, fileName = 'download') {
    // Add .csv extension if not already present
    const finalFileName = fileName.endsWith('.csv')
      ? fileName
      : `${fileName}.csv`;

    // Use Blob for all browsers (modern approach)
    const blob = new Blob([csvString], {
      type: 'text/csv;charset=utf-8;',
    });

    if (
      Object.hasOwnProperty.call(window, 'ActiveXObject') &&
      !window.ActiveXObject
    ) {
      // Determine if client is IE11
      // @ts-expect-error - msSaveBlob is not a standard method
      window.navigator.msSaveBlob(blob, finalFileName);
    } else {
      // Modern browsers
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('href', url);
      link.setAttribute('download', finalFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}
